// src/components/Navbar/Navbar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ logout }) => {
  const navigate = useNavigate();

  const username = localStorage.getItem('username');
  const userRole = localStorage.getItem('userRole');
  const isMPSI = username === 'MPSI' && userRole === 'MPSI_ADMIN';

  const handleLogout = () => {
    logout();
    localStorage.clear();
    navigate('/', { replace: true });
    window.location.reload();
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand p-0 ms-2">
        <img src="/logo_ds5.png" width={100} alt="Logo DS5" />
      </div>

      <ul className="nav-links">
        {/* Ces 3 liens n'apparaissent QUE pour MPSI */}
        {isMPSI && (
          <>
            <li><Link to="/app/client-dashboard">Cadence & Waiting</Link></li>
            <li><Link to="/app/jig">JIG MPSI</Link></li>
            <li><Link to="/app/historique-sn">Historique SN</Link></li>
          </>
        )}

        {/* Toujours visible pour tout le monde */}
        <li><Link to="/app/tester-interface">Test Reports</Link></li>
        <li><Link to="/app/user-settings">Settings</Link></li>
        <li><Link to="/app/operator-management">Operator Management</Link></li>
      </ul>

      <button className="logoutButton" onClick={handleLogout}>
        Logout
      </button>
    </nav>
  );
};

export default Navbar;